/* eslint-disable @typescript-eslint/no-var-requires */
export const headerDetails = require('./libs/phoenixPpv5HeaderDetails.graphql');
export const heroBannerQuery = require('./libs/phoenixPpv5HeroBanner.graphql');
export const phoenixPpv5Services = require('./libs/phoenixPpv5Services.graphql');
export const accuWeather = require('./libs/phoenixPpv5AccuWeather.graphql');
export const countryCodeDetails = require('./libs/phoenixPpv5CountryCodeDetails.graphql');
export const settlementCurrenyDetails = require('./libs/phoenixPpv5InternetPricing.graphql');
